import { render, staticRenderFns } from "./PlansEdit.vue?vue&type=template&id=3640446c&"
import script from "./PlansEdit.vue?vue&type=script&lang=js&"
export * from "./PlansEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports